import request from '@/libs/request'
// 获取商户信息


// export let baseUrl = process.env.NODE_ENV === 'development' ? '/pc4.2.0/api' : '/pc4.2.0/api'
// export let baseUrl = process.env.NODE_ENV === 'development' ? '/pc4.7.0/api' : '/pc4.7.0/api'
export let baseUrl = process.env.NODE_ENV === 'development' ? '/wsg/api' : '/wsg/api'

// export let baseUrl = 'http://123.57.63.39:8077/wsg'
// export let baseUrl = 'http://dzzs.acewill.cn:8000/wsg'
// export let baseUrl = 'http://dzzs-test.acewill.cn:80/wsg'

//看板首页获取各类预警数量（含已过期门店数据）
export function getWarningCount() {
    return request({
        url: baseUrl + '/statisticsSearch/warningCount',
        method: 'get'
    })
}
//获取指定月份评估分析概览数据
export function getEvaAnalOverview(year, month) {
    return request({
        url: baseUrl + `/statisticsSearch/evaAnalOverview/${year}/${month}`,
        method: 'get'
    })
}

//获取今日/本周/本月自检完成率概览数据
export function getExecAnalOverview() {
    return request({
        url: baseUrl + '/execute/overView',
        method: 'get'
    })
}
//不同任务周期的执行力概览
export function overviewByType(data) {
    return request({
        url: baseUrl + '/execute/overviewByType',
        method: 'post',
        data
    })
}
//查询区域层级执行力
export function getExecuteByLevel(data) {
    return request({
        url: baseUrl + '/execute/getExecuteByLevel',
        method: 'post',
        data
    })
}
//导出区域层级执行力
export function exportExecuteByLevel(data) {
    return request({
        timeout: 180000,
        responseType: 'blob',
        url: baseUrl + '/execute/achievingRate',
        method: 'post',
        data
    })
}
//查询自检列表
export function getRecordsByState(data) {
    return request({
        url: baseUrl + '/execute/getRecordsByState',
        method: 'post',
        data
    })
}

//查询所有商户信息
export function getBusiness(query) {
    return request({
        url: baseUrl + '/getBusiness',
        method: 'get',
        params: query
    })
}

// 获取商户配置信息
export function getLoginBusiness(query) {
    return request({
        url: baseUrl + '/getLoginBusiness',
        method: 'get',
        params: query
    })
}

// 更新商户配置信息
export function updateBusiness(query) {
    return request({
        url: baseUrl + '/updateBusiness',
        method: 'post',
        data: query
    })
}

// 增加商户信息
export function addBusiness(query) {
    return request({
        url: baseUrl + '/addBusiness',
        method: 'post',
        params: query
    })
}

// 删除商户信息
export function delBusiness(query) {
    return request({
        url: baseUrl + '/delBusiness',
        method: 'post',
        params: query
    })
}

// 获取省份和城市列表
export function getSysCity(query) {
    return request({
        url: baseUrl + '/getSysCity',
        method: 'get',
        params: query
    })
}

// 获取商圈信息
export function getBusinessCircle(query) {
    return request({
        url: baseUrl + '/getBusinessCircle',
        method: 'get',
        params: query
    })
}

// 获取门店标签以供选择
export function storeTagsForSelect() {
    return request({
        url: baseUrl + '/storeTagsForSelect',
        method: 'get'
    })
}

// 更新商圈信息
export function updateBusinessCircle(query) {
    return request({
        url: baseUrl + '/updateBusinessCircle',
        method: 'post',
        params: query
    })
}

// 增加商圈信息
export function addBusinessCircle(query) {
    return request({
        url: baseUrl + '/addBusinessCircle',
        method: 'post',
        params: query
    })
}

// 删除商圈信息
export function delBusinessCircle(query) {
    return request({
        url: baseUrl + '/delBusinessCircle',
        method: 'post',
        params: query
    })
}

// 获取任务标签信息
export function getTaskTags(query) {
    return request({
        url: baseUrl + '/getTaskTags',
        method: 'get',
        params: query
    })
}

// 更新任务标签信息
export function updateTaskTags(query) {
    return request({
        url: baseUrl + '/updateTaskTags',
        method: 'post',
        data: query
    })
}

// 增加任务标签信息
export function addTaskTags(query) {
    return request({
        url: baseUrl + '/addTaskTags',
        method: 'post',
        data: query
    })
}

// 删除任务标签信息
export function delTaskTags(query) {
    return request({
        url: baseUrl + '/delTaskTags',
        method: 'post',
        data: query
    })
}

// 获取品牌信息
export function getBrand(query) {
    return request({
        url: baseUrl + '/getBrand',
        method: 'get',
        params: query
    })
}

// 更新品牌信息
export function updateBrand(query) {
    return request({
        url: baseUrl + '/updateBrand',
        method: 'post',
        data: query
    })
}

// 增加品牌信息
export function addBrand(query) {
    return request({
        url: baseUrl + '/addBrand',
        method: 'post',
        data: query
    })
}

// 删除品牌信息
export function delBrand(query) {
    return request({
        url: baseUrl + '/delBrand',
        method: 'post',
        data: query
    })
}

// 获取业态信息
export function getBusinessFormat(query) {
    return request({
        url: baseUrl + '/getBusinessFormat',
        method: 'get',
        params: query
    })
}

// 获取公告信息
export function getPublicNotice(query) {
    return request({
        url: baseUrl + '/getPublicNotice',
        method: 'get',
        params: query
    })
}

// 更新公告信息
export function updatePublicNotice(query) {
    return request({
        url: baseUrl + '/updatePublicNotice',
        method: 'post',
        data: query
    })
}

// 增加公告信息
export function addPublicNotice(query) {
    return request({
        url: baseUrl + '/addPublicNotice',
        method: 'post',
        data: query
    })
}

// 删除公告信息
export function delPublicNotice(query) {
    return request({
        url: baseUrl + '/delPublicNotice',
        method: 'post',
        data: query
    })
}

// 获取门店信息
export function getStoreArchives(data) {
    return request({
        url: baseUrl + '/store',
        method: 'post',
        data
    })
}

export function updateStoreArchives(data) {
    return request({
        url: baseUrl + '/store',
        method: 'put',
        data
    })
}

// 增加门店信息
export function addStoreArchives(query) {
    return request({
        url: baseUrl + '/addStoreArchives',
        method: 'post',
        data: query
    })
}

// 删除门店信息
export function delStoreArchives(query) {
    return request({
        url: baseUrl + '/delStoreArchives',
        method: 'post',
        data: query
    })
}

// 获取区域信息
export function getArea(query) {
    return request({
        url: baseUrl + '/getArea',
        method: 'get',
        params: query
    })
}

// 更新区域信息
export function updateArea(query) {
    return request({
        url: baseUrl + '/updateArea',
        method: 'post',
        data: query
    })
}

// 增加区域信息
export function addArea(query) {
    return request({
        url: baseUrl + '/addArea',
        method: 'post',
        data: query
    })
}

// 删除区域信息
export function delArea(query) {
    return request({
        url: baseUrl + '/delArea',
        method: 'post',
        data: query
    })
}

// 查询所有树形 区域+门店
export function getTreeAreaStore(query) {
    return request({
        url: baseUrl + '/getTreeAreaStore',
        method: 'get',
        params: query
    })
}

// 查询叶子区域
export function getLeafArea(query) {
    return request({
        url: baseUrl + '/getLeafArea',
        method: 'get',
        params: query
    })
}

// 查询叶子区域
export function getAllLeafAreas() {
    return request({
        url: baseUrl + '/allLeafAreas',
        method: 'get'
    })
}

// 查询所有区域，返回树形结构
export function getAreaTree(query) {
    return request({
        url: baseUrl + '/areaTree',
        method: 'get',
        params: query
    })
}

// 查询所有树形 品牌+岗位模板
export function getTreeBrandPostTemplate(query) {
    return request({
        url: baseUrl + '/getTreeBrandPostTemplate',
        method: 'get',
        params: query
    })
}

// 新增/修改 区域时的 上一级区域 选项
export function upperLevel(query) {
    return request({
        url: baseUrl + '/upperLevel',
        method: 'get',
        params: query
    })
}
// 查询所有岗位信息
export function getRole(query) {
    return request({
        url: baseUrl + '/getRoles',
        method: 'get',
        params: query
    })
}

// 新增岗位
export function addRole(query) {
    return request({
        url: baseUrl + '/addRole',
        method: 'post',
        data: query
    })
}

// 修改岗位 state:1使用0停用
export function updateRole(query) {
    return request({
        url: baseUrl + '/updateRole',
        method: 'post',
        data: query
    })
}
// 查询所有部门信息
export function getDepartment(query) {
    return request({
        url: baseUrl + '/getDepartments',
        method: 'get',
        params: query
    })
}

// 新增部门
export function addDepartment(query) {
    return request({
        url: baseUrl + '/addDepartment',
        method: 'post',
        params: query
    })
}

// 修改部门 state:1使用0停用
export function updateDepartment(query) {
    return request({
        url: baseUrl + '/updateDepartment',
        method: 'post',
        params: query
    })
}
// 查询所有人员信息
export function getUsers(data) {
    return request({
        url: baseUrl + '/getUsers',
        method: 'post',
        data
    })
}

// 新增人员
export function addUser(query) {
    return request({
        url: baseUrl + '/addUser',
        method: 'post',
        data: query
    })
}

// 修改人员 state:1使用0停用
export function updateUser(query) {
    return request({
        url: baseUrl + '/updateUser',
        method: 'post',
        data: query
    })
}

// 重置用户密码
export function resetPwd(query) {
    return request({
        url: baseUrl + '/users/resetPwd',
        method: 'post',
        params: query
    })
}
// 部门树查询
export function getDepartmentTree(query) {
    return request({
        url: baseUrl + '/getDepartmentTree',
        method: 'get',
        params: query
    })
}
// 下级人员查询
export function getSubUser(query) {
    return request({
        url: baseUrl + '/getSubUser',
        method: 'get',
        params: query
    })
}
// 多条件查询任务信息
export function getTaskItem(query) {
    return request({
        url: baseUrl + '/getTaskItems',
        method: 'get',
        params: query
    })
}
// 新增任务项
export function addTaskItem(query) {
    return request({
        url: baseUrl + '/addTaskItem',
        method: 'post',
        data: query
    })
}
// 编辑任务项
export function updateTaskItem(query) {
    return request({
        url: baseUrl + '/updateTaskItem',
        method: 'post',
        data: query
    })
}
// 根据任务标准id查询任务标准分组以及任务项
export function getTaskGroups(query) {
    return request({
        url: baseUrl + '/getTaskGroups',
        method: 'get',
        params: query
    })
}
// 修改任务标准分组
export function updateTaskGroup(query) {
    return request({
        url: baseUrl + '/updateTaskGroup',
        method: 'post',
        data: query
    })
}
// 删除任务标准分组
export function deleteTaskGroup(groupId) {
    return request({
        url: baseUrl + `/taskGroup/${groupId}`,
        method: 'delete'
    })
}
// 新增任务标准分组
export function addTaskGroup(query) {
    return request({
        url: baseUrl + '/addTaskGroup',
        method: 'post',
        data: query
    })
}
// 添加任务项到任务标准分组
export function addItem2Group(query) {
    return request({
        url: baseUrl + '/addItem2Group',
        method: 'post',
        data: query
    })
}
// 多条件查询任务标准信息
export function getTask(query) {
    return request({
        url: baseUrl + '/getTasks',
        method: 'get',
        params: query
    })
}
// 任务标准修改,包括发布、撤回、编辑、删除
export function updateTask(query) {
    return request({
        url: baseUrl + '/updateTask',
        method: 'post',
        data: query
    })
}
// 新增任务标准
export function addTask(query) {
    return request({
        url: baseUrl + '/addTask',
        method: 'post',
        data: query
    })
}

// 门店列表下载
export function exportStoreInfoExcel(query) {
    return request({
        url: baseUrl + '/store/export',
        method: 'get',
        params: query
    })
}
// 门店模板下载
export function exportStoreTemplate(query) {
    return request({
        header: { 'Content-Type': 'application/vnd.ms-excel;charset=UTF-8' },
        url: baseUrl + '/store/template',
        method: 'get',
        params: query
    })
}
// 上传失败门店列表下载
export function exportStoreErrorImportList(query) {
    return request({
        url: baseUrl + '/store/error',
        method: 'get',
        params: query
    })
}
// 导入门店列表
export function importStoreInfoExcel(query) {
    return request({
        headers: { 'Content-Type': 'multipart/form-data' },
        url: baseUrl + '/store/import',
        method: 'post',
        data: query
    })
}
//导出门店Excel
export function exportStoreExcel(query) {
    return request({
        timeout: 180000,
        responseType: 'blob',
        url: `${baseUrl}/store/export?${query ? query.slice(0, -1) : ""}`,
        method: 'get'
    })
}
export function uploadStorePic(query) {
    return request({
        headers: { 'Content-Type': 'multipart/form-data' },
        url: baseUrl + '/store/upload',
        method: 'post',
        data: query
    })
}
export function upload(data, path) {
    let param = path ? `?path=${path}` : ''
    return request({
        headers: { 'Content-Type': 'multipart/form-data' },
        url: baseUrl + '/upload' + param,
        method: 'post',
        data
    })
}

// 多条件查询任务模板的任务标准信息
export function getTaskTemplateAssess(params) {
    return request({
        url: baseUrl + '/taskTemplateAssess/list',
        method: 'get',
        params
    })
}

// 新增任务模板的任务标准
export function addTaskTemplateAssess(data) {
    return request({
        url: baseUrl + '/taskTemplateAssess',
        method: 'post',
        data
    })
}

// 修改任务模板的任务标准
export function updateTaskTemplateAssess(data) {
    return request({
        url: baseUrl + '/taskTemplateAssess',
        method: 'put',
        data
    })
}
export function returnTask(taskRecordId) {
    return request({
        url: baseUrl + `/report/return/${taskRecordId}`,
        method: 'put',

    })
}

// 删除任务模板的任务标准
export function deleteTaskTemplateAssess(params) {
    return request({
        url: baseUrl + `/taskTemplateAssess/${params}`,
        method: 'delete'
    })
}


export function getLoginUser(query) {
    return request({
        url: baseUrl + '/getLoginUser',
        method: 'get',
        params: query
    })
}

export function login(query) {
    return request({
        url: baseUrl + '/login',
        method: 'post',
        data: query
    })
}

export function getTaskAll(query) {
    return request({
        url: baseUrl + '/getTaskAll',
        method: 'get',
        params: query
    })
}

export function exportTaskItemExcel(query) {
    return request({
        url: baseUrl + '/exportTaskItemExcel',
        method: 'get',
        params: query
    })
}

export function exportTaskItemErrorImportList(query) {
    return request({
        url: baseUrl + '/exportTaskItemErrorImportList',
        method: 'get',
        params: query
    })
}

export function exportTaskItemTemplate(query) {
    return request({
        url: baseUrl + '/exportTaskItemTemplate',
        method: 'get',
        params: query
    })
}

export function importTaskItemExcel(query) {
    return request({
        headers: { 'Content-Type': 'multipart/form-data' },
        url: baseUrl + '/importTaskItemExcel',
        method: 'post',
        data: query
    })
}

export function deleteItem4Group(query) {
    return request({
        url: baseUrl + '/deleteItem4Group',
        method: 'post',
        data: query
    })
}

export function getTaskGroupsByGroupId(query) {
    return request({
        url: baseUrl + '/getTaskGroupsByGroupId',
        method: 'get',
        params: query
    })
}

export function importUserInfoExcel(query) {
    return request({
        headers: { 'Content-Type': 'multipart/form-data' },
        url: baseUrl + '/importUserInfoExcel',
        method: 'post',
        data: query
    })
}

export function getTaskRecordInfo(query) {
    return request({
        url: baseUrl + '/getTaskRecordInfo',
        method: 'get',
        params: query
    })
}

export function getTaskItemsTag(query) {
    return request({
        url: baseUrl + '/getTaskItemsTag',
        method: 'get',
        params: query
    })
}

export function addTaskItemTag(query) {
    return request({
        url: baseUrl + '/addTaskItemTag',
        method: 'post',
        data: query
    })
}

export function updateTaskItemTag(query) {
    return request({
        url: baseUrl + '/updateTaskItemTag',
        method: 'post',
        data: query
    })
}

export function findValidAssessItemsByAssessId(query) {
    return request({
        url: baseUrl + '/findValidAssessItemsByAssessId',
        method: 'get',
        params: query
    })
}

// 查询全部启用的任务项，供前端选择控件使用
export function assessItemsForSelect(params) {
    return request({
        url: baseUrl + '/assessItemsForSelect',
        method: 'get',
        params
    })
}

export function getMarketSeparation(query) {
    return request({
        url: baseUrl + '/getMarketSeparation',
        method: 'get',
        params: query
    })
}

export function addMarketSeparation(query) {
    return request({
        url: baseUrl + '/addMarketSeparation',
        method: 'post',
        data: query
    })
}

export function updateMarketSeparation(query) {
    return request({
        url: baseUrl + '/updateMarketSeparation',
        method: 'post',
        data: query
    })
}

export function getTargetRule(query) {
    return request({
        url: baseUrl + '/getTargetRule',
        method: 'get',
        params: query
    })
}

export function addTargetRule(query) {
    return request({
        url: baseUrl + '/addTargetRule',
        method: 'post',
        data: query
    })
}

export function updateTargetRule(query) {
    return request({
        url: baseUrl + '/updateTargetRule',
        method: 'post',
        data: query
    })
}

export function getMenuTree(query) {
    return request({
        url: baseUrl + '/getMenuTree',
        method: 'get',
        params: query
    })
}

export function getRoleMenusIds(query) {
    return request({
        url: baseUrl + '/getRoleMenusIds',
        method: 'get',
        params: query
    })
}

export function saveRoleMenus(query) {
    return request({
        url: baseUrl + '/saveRoleMenus',
        method: 'post',
        data: query
    })
}

export function findTaskPermission(query) {
    return request({
        url: baseUrl + '/findTaskPermission',
        method: 'get',
        params: query
    })
}

export function findTaskPermissionByRoleId(query) {
    return request({
        url: baseUrl + '/findTaskPermissionByRoleId',
        method: 'get',
        params: query
    })
}

export function saveTaskPermission(query) {
    return request({
        url: baseUrl + '/saveTaskPermission',
        method: 'post',
        data: query
    })
}

export function modifyPwd(query) {
    return request({
        url: baseUrl + '/modifyPwd',
        method: 'post',
        data: query
    })
}

export function addWorkScoreType(query) {
    return request({
        url: baseUrl + '/workScoreType/add',
        method: 'post',
        data: query
    })
}

export function eidtWorkScoreType(query) {
    return request({
        url: baseUrl + '/workScoreType/edit',
        method: 'post',
        data: query
    })
}

export function getWorkScoreType(query) {
    return request({
        url: baseUrl + '/workScoreType/get',
        method: 'get',
        params: query
    })
}

export function listWorkScoreType(query) {
    return request({
        url: baseUrl + '/workScoreType/list',
        method: 'get',
        params: query
    })
}

export function removeWorkScoreType(query) {
    return request({
        url: baseUrl + '/workScoreType/remove',
        method: 'post',
        data: query
    })
}

// 工分条例列表下载
export function workScoreRegulationExportExcel(query) {
    return request({
        url: baseUrl + '/workScoreRegulation/exportExcel',
        method: 'get',
        params: query
    })
}

// 上传工分条例失败项下载
export function workScoreRegulationExportImportList(query) {
    return request({
        url: baseUrl + '/workScoreRegulation/exportImportList',
        method: 'get',
        params: query
    })
}

// 根据id查询工分条例
export function getWorkScoreRegulation(query) {
    return request({
        url: baseUrl + '/workScoreRegulation/get',
        method: 'get',
        params: query
    })
}

// 多条件查询工分条例
export function listWorkScoreRegulation(query) {
    return request({
        url: baseUrl + '/workScoreRegulation/list',
        method: 'get',
        params: query
    })
}

// 工分条例导入模板下载
export function workScoreRegulationImportTemplate(query) {
    return request({
        url: baseUrl + '/workScoreRegulation/importTemplate',
        method: 'get',
        params: query
    })
}

// 增加工分条例
export function addWorkScoreRegulation(query) {
    return request({
        url: baseUrl + '/workScoreRegulation/add',
        method: 'post',
        data: query
    })
}

// 编辑工分条例
export function editWorkScoreRegulation(query) {
    return request({
        url: baseUrl + '/workScoreRegulation/edit',
        method: 'post',
        data: query
    })
}

// 删除工分条例
export function removeWorkScoreRegulation(query) {
    return request({
        url: baseUrl + '/workScoreRegulation/remove',
        method: 'post',
        data: query
    })
}

// 工分条例上传
export function workScoreRegulationImportExcel(query) {
    return request({
        url: baseUrl + '/workScoreRegulation/importExcel',
        method: 'post',
        data: query
    })
}

// 工分制度管理

// 多条件查询工分制度
export function listWorkScoreSystem(query) {
    return request({
        url: baseUrl + '/workScoreSystem/list',
        method: 'get',
        params: query
    })
}

// 根据id查询工分制度
export function getWorkScoreSystem(query) {
    return request({
        url: baseUrl + '/workScoreSystem/get',
        method: 'get',
        params: query
    })
}

// 根据工分制度id查询工分条例
export function getRegulationByScoreSystem(query) {
    return request({
        url: baseUrl + '/workScoreSystem/getRegulation',
        method: 'get',
        params: query
    })
}

// 工分制度删除工分条例
export function getUnBindingRegulations(query) {
    return request({
        url: baseUrl + '/workScoreSystem/getUnBindingRegulations',
        method: 'get',
        params: query
    })
}

// 根据工分制度绑定工分条例
export function scoreSystemAddRegulation(query) {
    return request({
        url: baseUrl + '/workScoreSystem/addRegulation',
        method: 'post',
        data: query
    })
}

// 根据工分制度解绑工分条例
export function scoreSystemDelRegulation(query) {
    return request({
        url: baseUrl + '/workScoreSystem/delRegulation',
        method: 'post',
        data: query
    })
}

// 增加工分制度
export function addWorkScoreSystem(query) {
    return request({
        url: baseUrl + '/workScoreSystem/add',
        method: 'post',
        data: query
    })
}

// 编辑工分制度
export function editWorkScoreSystem(query) {
    return request({
        url: baseUrl + '/workScoreSystem/edit',
        method: 'post',
        data: query
    })
}

// 删除工分制度
export function removeWorkScoreSystem(query) {
    return request({
        url: baseUrl + '/workScoreSystem/remove',
        method: 'post',
        data: query
    })
}

// 工分规则管理

// 多条件查询工分规则
export function listWorkScoreRule(query) {
    return request({
        url: baseUrl + '/workScoreRule/list',
        method: 'get',
        params: query
    })
}

// 根据id查询工分规则
export function getWorkScoreRule(query) {
    return request({
        url: baseUrl + '/workScoreRule/get',
        method: 'get',
        params: query
    })
}

// 增加工分规则
export function addWorkScoreRule(query) {
    return request({
        url: baseUrl + '/workScoreRule/add',
        method: 'post',
        data: query
    })
}

// 编辑工分规则
export function editWorkScoreRule(query) {
    return request({
        url: baseUrl + '/workScoreRule/edit',
        method: 'post',
        data: query
    })
}

// 删除工分规则
export function removeWorkScoreRule(query) {
    return request({
        url: baseUrl + '/workScoreRule/remove',
        method: 'post',
        data: query
    })
}

// 获取上级人员
export function getUpperUser(query) {
    return request({
        url: baseUrl + '/getUpperUser',
        method: 'get',
        params: query
    })
}

// 查询工分制报表
export function findUserWorkScore(query) {
    return request({
        url: baseUrl + '/findUserWorkScore',
        method: 'post',
        data: query
    })
}

// 查询工分制报表导出ID
export function getWorkScoreExcelId(query) {
    return request({
        url: baseUrl + '/getWorkScoreExcelId',
        method: 'post',
        data: query
    })
}

// 查询工分制报表基础信息
export function getWorkScoreCondition(query) {
    return request({
        url: baseUrl + '/getWorkScoreCondition',
        method: 'get',
        params: query
    })
}

// 根据任务记录id查询巡检任务
export function getFindTaskDetailById(query) {
    return request({
        url: baseUrl + `/report/findTaskDetailById/${query.recordId}/${query.reportShowType}`,
        method: 'get',
        // params: query
    })
}
// 自检/巡检：根据任务id查询任务详情
export function findTaskDetailById(trId) {
    return request({
        url: baseUrl + `/task/findTaskDetailById/${trId}`,
        method: 'get'
    })
}
// 自检/巡检：加锁/解锁
export function lockTask(trId, type) {
    return request({
        url: baseUrl + `/task/lock/${trId}/${type}`,
        method: 'put'
    })
}
// 获取上次失分项详情
export function getLastLoseItem(tirId) {
    return request({
        url: baseUrl + `/task/lastLoseItemDetail/${tirId}`,
        method: 'get'
    })
}
// H5端提交任务项/签名图
export function execTaskItemH5(trId, tirList, signSource) {
    return request({
        url: baseUrl + '/task/execTaskItemH5',
        method: 'put',
        data: {
            taskRecordId: trId,
            items: tirList,
            signSource
        }
    })
}
// 自检/巡检：提交
export function submitTask(trId) {
    return request({
        url: baseUrl + `/task/submit/${trId}`,
        method: 'put'
    })
}

// 获取整改执行人
export function getCorrectProcessor(trId) {
    return request({
        url: baseUrl + `/correctCreate/selectProcessor?taskRecdId=${trId}`,
        method: 'get',
    })
}
// 获取评估项下的整改
export function getCorrectInTir(trId, tirId) {
    return request({
        url: baseUrl + `/correctCreate/select?taskRecdId=${trId}&taskItemRecdId=${tirId}`,
        method: 'get',
    })
}
// 添加评估项下全部整改
export function addCorrectInTir(data) {
    return request({
        url: baseUrl + '/correctCreate/add',
        method: 'post',
        data
    })
}
// 删除指定整改
export function deleteCorrectById(crId) {
    return request({
        url: baseUrl + '/correctCreate/delete',
        method: 'post',
        data: { corRecdId: crId }
    })
}


// 查询任务项图片
export function getFindPictureById(query, phoneUrlType) {
    return request({
        url: baseUrl + `/report/findPictureById/${query}/${phoneUrlType}`,
        method: 'get',
    })
}

// 获查询巡检报表的条件数据
export function getCondition(query) {
    return request({
        url: baseUrl + `/report/condition/${query}`,
        method: 'get',
    })
}

// 查询巡检任务项报表
export function findReportDetail(query) {
    return request({
        url: baseUrl + '/report/detail',
        method: 'post',
        data: query
    })
}

// 查询巡检报表
export function findReportResult(query) {
    return request({
        url: baseUrl + '/report/result',
        method: 'post',
        data: query
    })
}
// 发起评估报表归档任务
export function startArchivingTask(data) {
    return request({
        url: baseUrl + '/report/reportArchivingTask',
        method: 'post',
        data
    })
}
// 获取正在执行的评估报表归档任务
export function getArchivingTask() {
    return request({
        url: baseUrl + '/report/reportArchivingTask',
        method: 'get',
    })
}
// 获取已完成的评估报表归档文件
export function getArchivingFiles(params) {
    return request({
        url: baseUrl + '/report/reportArchivingFiles',
        method: 'get',
        params
    })
}

// 查询登录日志报表
export function getLoginRecords(query) {
  return request({
    url: baseUrl + '/log/getLoginRecords',
    method: 'post',
    data: query
  })
}



// 获取巡检任务项列表id
export function getRoutInspectItemExcelId(query) {
    return request({
        url: baseUrl + '/getRoutInspectItemExcelId',
        method: 'post',
        data: query
    })
}


// 多条件查询可用的未绑定整改项信息
export function findValidCorrectItemsByCorTemptId(query) {
    return request({
        url: baseUrl + '/correctTemplate/findValidCorrectItemsByCorTemptId',
        method: 'get',
        params: query
    })
}

// 根据整改模板id获取模板和已绑定整改项信息，用于设置整改项或预览
export function getCorrectItemsByCorTemptId(query) {
    return request({
        url: baseUrl + '/correctTemplate/getCorrectItemsByCorTemptId',
        method: 'get',
        params: query
    })
}

// 多条件查询整改模板信息
export function getCorrectTemplate(query) {
    return request({
        url: baseUrl + '/correctTemplate/getCorrectTemplate',
        method: 'get',
        params: query
    })
}

// 新建整改模板
export function addCorrectTemplate(query) {
    return request({
        url: baseUrl + '/correctTemplate/addCorrectTemplate',
        method: 'post',
        data: query
    })
}

// 添加整改项到整改模板（可批量）
export function addItem2CorTempt(query) {
    return request({
        url: baseUrl + '/correctTemplate/addItem2CorTempt',
        method: 'post',
        data: query
    })
}

// 从整改模板删除整改项（可批量）
export function deleteItem4CorTempt(query) {
    return request({
        url: baseUrl + '/correctTemplate/deleteItem4CorTempt',
        method: 'post',
        data: query
    })
}

// 整改模板修改,包括发布、撤回、编辑、删除
export function updateCorrectTemplate(query) {
    return request({
        url: baseUrl + '/correctTemplate/updateCorrectTemplate',
        method: 'post',
        data: query
    })
}

// 获取用户未过期营业门店，用于单选
export function getUserStoresForSelect() {
    return request({
        url: baseUrl + '/store/currentUserStores',
        method: 'get'
    })
}

// 获取全部设备列表
export function getWholeDeviceList(params) {
    return request({
        url: baseUrl + '/device/getDeviceList',
        method: 'get',
        params
    })
}

// 获取各设备列表
export function getEachDeviceList(params) {
    return request({
        url: baseUrl + '/device/getDeviceCount',
        method: 'get',
        params
    })
}

// 获取查询设备管理列表
export function getDeviceList(params) {
    return request({
        url: baseUrl + '/device/list',
        method: 'get',
        params
    })
}

// 添加设备
export function getDeviceAdd(data) {
    return request({
        url: baseUrl + '/device/add',
        method: 'post',
        data
    })
}

// 修改设备名称
export function updateName(data) {
    return request({
        url: baseUrl + '/device/name',
        method: 'put',
        data
    })
}

// 删除设备
export function deleteDevice(brand, serial) {
    return request({
        url: baseUrl + `/device/${brand}/${serial}`,
        method: 'delete'
    })
}

// 根据门店 id查询已绑定设备
export function getStoreDevice(params) {
    return request({
        url: baseUrl + '/device/getStoreDevice',
        method: 'get',
        params
    })
}

// 修改非萤石云设备关联的门店
export function changeDeviceStore(deviceId, storeId) {
    return request({
        url: baseUrl + `/device/changeDeviceStore/${deviceId}/${storeId}`,
        method: 'put'
    })
}

// 根据门店 id查询未绑定设备
export function getNoBindStoreDeviceList(params) {
    return request({
        url: baseUrl + '/device/getNoBindStoreDeviceList',
        method: 'get',
        params
    })
}


// 门店绑定设备接口
export function storeBindDevice(data) {
    return request({
        url: baseUrl + '/device/storeBindDevice',
        method: 'post',
        data
    })
}

// 获取所有门店
export function getNoCloseStoreList(params) {
    return request({
        url: baseUrl + '/device/getNoCloseStoreList',
        method: 'get',
        params
    })
}


// 获取ehr职位列表
export function getEhrPositionList(params) {
    return request({
        url: baseUrl + '/getEhrPositionList',
        method: 'get',
        params
    })
}
// 获取ehr岗位列表
export function getEhrPosts() {
    return request({
        url: baseUrl + '/ehrPosts',
        method: 'get'
    })
}
// 获取商户本地通用配置
export function getLocalConfig(params) {
    return request({
        url: baseUrl + '/localConfig',
        method: 'get',
        params
    })
}

// 获取 ehr 的门店基础数据
export function getEhrStoreList() {
    return request({
        url: baseUrl + '/getEhrStoreList',
        method: 'get',
    })
}

// 修改商户本地通用配置
export function updateLocalConfig(data) {
    return request({
        url: baseUrl + '/localConfig',
        method: 'post',
        data
    })
}


// 获取分享身份
export function getUsersForSelect(params) {
    return request({
        url: baseUrl + '/usersForSelect',
        method: 'get',
        params
    })
}


// 获取审批流管理页面表格中的数据
export function checkFlowsList(params) {
    return request({
        url: baseUrl + '/checkFlow/checkFlows',
        method: 'get',
        params
    })
}
// 删除审批流
export function deleteCheckFlowsList(params) {
    return request({
        url: baseUrl + `/checkFlow/checkFlow/${params}`,
        method: 'delete',
    })
}
// 获取单个审批流详细数据
export function getCheckFlowsItem(params) {
    return request({
        url: baseUrl + `/checkFlow/checkFlow/${params}`,
        method: 'get',
    })
}
// 新增或编辑审批流
export function addOrUpdateCheckFlow(data) {
    return request({
        url: baseUrl + '/checkFlow/checkFlow',
        method: 'post',
        data
    })
}
// 获取全部启用审批流以供前端页面选择
export function checkFlowsForSelect(params) {
    return request({
        url: baseUrl + '/checkFlow/checkFlowsForSelect',
        method: 'get',
        params
    })
}
// 返回选中人员的头像
export function userImages(data) {
    return request({
        url: baseUrl + '/userImages',
        method: 'post',
        data
    })
}



// 获取全部启用角色，只返回必要字段
export function rolesForSelect(params) {
    return request({
        url: baseUrl + '/rolesForSelect',
        method: 'get',
        params
    })
}

//以部门树状结构返回全部在职用户
export function getUsersInTree() {
    return request({
        url: baseUrl + '/usersInDepartmentTree',
        method: 'get'
    })
}

// 获取所有签到属性
export function getCheckAttributes(params) {
    return request({
        url: baseUrl + '/getCheckAttributes',
        method: 'get',
        params
    })
}
// 签到统计记录列表下载
export function getCheckClockExcelId(data) {
    return request({
        url: baseUrl + '/getCheckClockExcelId',
        method: 'post',
        data
    })
}
// 查询签到统计报表
export function findCheckClockReport(data) {
    return request({
        url: baseUrl + '/findCheckClockReport',
        method: 'post',
        data
    })
}
// 获取查询签到统计报表的条件数据
export function getCheckClockCondition(params) {
    return request({
        url: baseUrl + '/getCheckClockCondition',
        method: 'get',
        params
    })
}
// 根据查询条件获取人员轨迹报表
export function getPositioningReport(data) {
    return request({
        url: baseUrl + `/positioningReport`,
        method: 'post',
        data
    })
}
// 根据查询条件导出人员轨迹报表
export function getPositioningExcel(data) {
    return request({
        responseType: 'blob',
        url: baseUrl + `/positioningExcel`,
        method: 'post',
        data
    })
}



/**日程相关接口 */
//查看日程列表(日历样式)
export function listInCalendar(data) {
    return request({
        url: baseUrl + '/calendar/listInCalendar',
        method: 'post',
        data
    })
}

//查询条件一 执行人
export function getCalendarCondition(params) {
    return request({
        url: baseUrl + '/calendar/getCalendarCondition',
        method: 'get',
        params
    })
}

//查询条件二 任务
export function getTaskByUserId(data) {
    return request({
        url: baseUrl + '/calendar/getTaskByUserId',
        method: 'post',
        data
    })
}

//查询条件三 门店范围
export function getStoreByUserIdAndTaskId(data) {
    return request({
        url: baseUrl + '/calendar/getStoreByUserIdAndTaskId',
        method: 'post',
        data
    })
}

//创建日程
export function calendar(data) {
    return request({
        url: baseUrl + '/calendar/calendar',
        method: 'post',
        data
    })
}
// 多条件查询任务模板
export function taskTemplateList(query) {
    return request({
        url: baseUrl + '/taskTemplate/list',
        method: 'get',
        params: query
    })
}

// 获取分享身份
export function getIdentities(query) {
    return request({
        url: baseUrl + '/taskTemplate/identities',
        method: 'get',
        params: query
    })
}

// 任务模板启用/停用
export function updateTaskTemplateState(params) {
    return request({
        url: baseUrl + `/taskTemplate/${params.id}/${params.state}`,
        method: 'delete',
    })
}
// 任务模板批量启用
export function enableTaskTemplates(data) {
    return request({
        url: baseUrl + `/taskTemplate/enable`,
        method: 'put',
        data
    })
}

// 新增任务模板
export function addTemplateState(data) {
    return request({
        url: baseUrl + '/taskTemplate',
        method: 'post',
        data
    })
}

//查看日程详情
export function calendarDetail(params) {
    return request({
        url: baseUrl + `/calendar/detail${params}`,
        method: 'get',
        // params
    })
}

//所有门店
export function getBrandStoreList(params) {
    return request({
        url: baseUrl + '/calendar/getBrandStoreList',
        method: 'get',
        params
    })
}

//编辑日程
export function calendarEdit(data) {
    return request({
        url: baseUrl + '/calendar/calendar',
        method: 'put',
        data
    })
}
// 修改任务模板
export function updateTemplateState(data) {
    return request({
        url: baseUrl + '/taskTemplate',
        method: 'put',
        data
    })
}

// 获取全部责任标签
export function getResponsibleLabels() {
    return request({
        url: baseUrl + '/taskTemplate/responsibleLabels',
        method: 'get'
    })
}
// 保存责任标签
export function saveResponsibleLabel(data) {
    return request({
        url: baseUrl + '/taskTemplate/responsibleLabel',
        method: 'post',
        data
    })
}
// 删除责任标签
export function deleteResponsibleLabel(rlId) {
    return request({
        url: baseUrl + `/taskTemplate/responsibleLabel/${rlId}`,
        method: 'delete'
    })
}

// 查询整改详情
export function getSelectDetail(params) {
    return request({
        method: 'get',
        url: baseUrl + '/correctExecute/selectDetail',
        params
    })
}




// 查询整改报表
export function getCorrect(data) {
    return request({
        method: 'post',
        url: baseUrl + '/report/correct',
        data
    })
}

//删除日程
export function calendarDelete(params) {
    return request({
        url: baseUrl + `/calendar/calendar${params}`,
        method: 'DELETE',
        // params
    })
}

//日程列表样式
export function listInRow(data) {
    return request({
        url: baseUrl + '/calendar/listInRow',
        method: 'post',
        data
    })
}

//日程记录id
export function getCalendarExcelId(query) {
    return request({
        url: baseUrl + '/calendar/getCalendarExcelId',
        method: 'post',
        data: query
    })
}

//派发任务
export function taskGroup(query) {
    return request({
        url: baseUrl + '/assignTaskGroup/taskGroup',
        method: 'get',
        params: query
    })
}
//根据类型获取门店筛选条件
export function getStoreConditionByType(query) {
    return request({
        url: baseUrl + `/assignTaskGroup/getStoreConditionByType/${query}`,
        method: 'get'
    })
}

//查询门店列表
export function getStoreByCondition(query) {
    return request({
        url: baseUrl + '/assignTaskGroup/getStoreByCondition',
        method: 'post',
        data: query
    })
}

//任务配置获取所有巡检任务
export function getTaskTemplate(query) {
    return request({
        url: baseUrl + '/assignTaskGroup/getTaskTemplate',
        method: 'get',
        query
    })
}

//任务配置根据任务ID获取适用的角色
export function getRoleByTaskTemplateId(query) {
    return request({
        url: baseUrl + `/assignTaskGroup/getRoleByTaskTemplateId/${query}`,
        method: 'get'
    })
}

//查询预发布任务
export function previewTaskGroup(query) {
    return request({
        url: baseUrl + '/assignTaskGroup/previewTaskGroup',
        method: 'post',
        data: query
    })
}

//查询预发布任务
export function previewTask(query) {
    return request({
        url: baseUrl + '/assignTaskGroup/previewTask',
        method: 'get',
        params: query
    })
}

//单个数据删除发布任务
export function previewTaskGroupDelete(params) {
    return request({
        url: baseUrl + `/assignTaskGroup/previewTaskGroup/${params}`,
        method: 'DELETE',
        // params
    })
}

//多选删除预发布任务
export function previewTaskDetele(query) {
    return request({
        url: baseUrl + '/assignTaskGroup/previewTask',
        method: 'DELETE',
        data: query
    })
}

//发布任务
export function previewTaskPost(query) {
    return request({
        url: baseUrl + `/assignTaskGroup/previewTaskGroup/${query}`,
        method: 'put'
    })
}

//编辑任务
export function previewTaskPut(data) {
    return request({
        url: baseUrl + '/assignTaskGroup/previewTask',
        method: 'put',
        data
    })
}


// 获取查询报表的条件数据
export function getCorrectCondition(params) {
    return request({
        method: 'get',
        url: baseUrl + '/report/correct/condition',
        params
    })
}


// 查询整改详情
export function getCorrectSelectDetail(params) {
    return request({
        method: 'get',
        url: baseUrl + '/report/correct/selectDetail',
        params
    })
}


// 上传区域列表
export function importAreaInfoExcel(query) {
    return request({
        headers: { 'Content-Type': 'multipart/form-data' },
        url: baseUrl + '/areaImport',
        method: 'post',
        data: query
    })
}

//查询任务组报告
export function taskReport(query) {
    return request({
        url: baseUrl + '/assignTaskGroup/taskReport',
        method: 'get',
        params: query
    })
}

//查询派发任务执行人id
export function getUserByTaskTemplateIdAndStoreId(query) {
    return request({
        url: baseUrl + '/assignTaskGroup/getUserByTaskTemplateIdAndStoreId',
        method: 'get',
        params: query
    })
}

//查询报告状态
export function taskReportStatus(query) {
    return request({
        url: baseUrl + '/assignTaskGroup/taskReportStatus',
        method: 'get',
        params: query
    })
}

//异常任务
export function previewListCount(query) {
    return request({
        url: baseUrl + '/assignTaskGroup/previewListCount',
        method: 'get',
        params: query
    })
}

//获取部门权限下的人员
export function getCurAndSubUser(query) {
    return request({
        url: baseUrl + '/getCurAndSubUser',
        method: 'get',
        params: query
    })
}


// 获取起止日期内有效的评估标准
export function getAssessments(params, type, cycle) {
    return request({
        url: baseUrl + `/statisticsSearch/assessments/${params.startDay}/${params.endDay}${Number(type) > 0 ? `?taskType=${type}` : ''}${Number(cycle) > 0 ? `?cycleType=${cycle}` : ''}`,
        method: 'get',
    })
}

// 获取指定任务标准的树形分组
export function getGroupTree(assessId) {
    return request({
        url: baseUrl + `/statisticsSearch/groupTree/${assessId}`,
        method: 'get',
    })
}

export function getEavAnlysTasks(params) {
    return request({
        url: baseUrl + `/statisticsSearch/tasks/${params.startDay}/${params.endDay}/${params.assessId}`,
        method: 'get',
    })
}

// 获取当前用户管辖门店
export function getUserStores(params) {
    return request({
        url: baseUrl + '/statisticsSearch/userStores',
        method: 'get',
        params
    })
}


// 获取得分最低评估
export function getLowestScore(data, options = {}) {
    return request({
        method: 'post',
        url: baseUrl + `/statisticsScore/lowestScore${options.pageNum ? '?' + 'pageNum=' + options.pageNum + '&pageSize=' + options.pageSize : ''}`,
        data
    })
}

// 导出得分最低评估
export function getLowestScoreExcel(data) {
    return request({
        responseType: 'blob',
        method: 'post',
        url: baseUrl + `/statisticsScore/lowestScoreExcel`,
        data
    })
}

// 获取评估成绩top排行
export function getRank(areaLevel, data, options = {}) {
    return request({
        method: 'post',
        url: baseUrl + `/statisticsScore/rank/${areaLevel}${options.pageNum ? '?' + 'pageNum=' + options.pageNum + '&pageSize=' + options.pageSize : ''}`,
        data
    })
}

// 导出评估成绩top排行
export function getRankExcel(areaLevel, data) {
    return request({
        responseType: 'blob',
        method: 'post',
        url: baseUrl + `/statisticsScore/rankExcel/${areaLevel}`,
        data,
    })
}

// 获取趋势分析
export function getScoreTrend(timeScale, data) {
    return request({
        method: 'post',
        url: baseUrl + `/statisticsScore/scoreTrend/${timeScale}`,
        data
    })
}

// 导出趋势分析
export function getScoreTrendExcel(timeScale, data) {
    return request({
        responseType: 'blob',
        method: 'post',
        url: baseUrl + `/statisticsScore/scoreTrendExcel/${timeScale}`,
        data
    })
}


// 获取评估成绩总览
export function getOverview(data) {
    return request({
        method: 'post',
        url: baseUrl + '/statisticsScore/overview',
        data
    })
}

// 获取区域对比
export function getAreaCompare(areaLevel, data) {
    return request({
        method: 'post',
        url: baseUrl + `/statisticsScore/areaCompare/${areaLevel}`,
        data
    })
}

// 获取区域对比
export function getAreaCompareExcel(areaLevel, data) {
    return request({
        responseType: 'blob',
        method: 'post',
        url: baseUrl + `/statisticsScore/areaCompareExcel/${areaLevel}`,
        data
    })
}

// 获取点击 "趋势分析" 某一项后跳转到的评估结果页面数据
export function getTrendEvaResult(data, options) {
    return request({
        method: 'post',
        url: baseUrl + `/statisticsScore/trendEvaResult${options.pageNum ? '?' + 'pageNum=' + options.pageNum + '&pageSize=' + options.pageSize : ''}`,
        data
    })
}

// 导出点击 "趋势分析" 某一项后跳转到的评估结果页面数据
export function getTrendEvaResultExcel(data) {
    return request({
        responseType: 'blob',
        method: 'post',
        url: baseUrl + `/statisticsScore/trendEvaResultExcel`,
        data
    })
}

// 获取点击 "Top排行/区域对比" 某一项后跳转的评估结果页面数据
export function getEvaResult(areaLevel, id, data, options = {}) {
    return request({
        method: 'post',
        url: baseUrl + `/statisticsScore/evaResult/${areaLevel}/${id}${options.pageNum ? '?' + 'pageNum=' + options.pageNum + '&pageSize=' + options.pageSize : ''}`,
        data
    })
}

// 导出点击 "Top排行/区域对比" 某一项后跳转的评估结果页面数据
export function getEvaResultExcel(areaLevel, id, data) {
    return request({
        responseType: 'blob',
        method: 'post',
        url: baseUrl + `/statisticsScore/evaResultExcel/${areaLevel}/${id}`,
        data
    })
}

// 获取评估问题Top失分项
export function getQuestionList(data, options = {}) {
    return request({
        method: 'post',
        url: baseUrl + `/statisticsQuestion/list${options.pageNum ? '?' + 'pageNum=' + options.pageNum + '&pageSize=' + options.pageSize : ''}`,
        data
    })
}


// 看明细
export function getQuestionDetailById(data) {
    return request({
        method: 'post',
        url: baseUrl + `/statisticsQuestion/detailById`,
        data
    })
}


// 获取评估大项得分率
export function getQuestionGroupScoreRate(groupLevel, data) {
    return request({
        method: 'post',
        url: baseUrl + `/statisticsQuestion/groupScoreRate/${groupLevel}`,
        data
    })
}

// 获取评估问题总览
export function getQuestionOverview(data) {
    return request({
        method: 'post',
        url: baseUrl + `/statisticsQuestion/overview`,
        data
    })
}

// 看责任
export function getQuestionOwnerById(options, data) {
    return request({
        method: 'post',
        url: baseUrl + `/statisticsQuestion/ownerById/${options.areaLevel}/${options.orderType}/${options.areaId}/${options.isEnd}`,
        data
    })
}

// 查询具体任务项的失分概括
export function questionById(data) {
    return request({
        method: 'post',
        url: baseUrl + `/statisticsQuestion/questionById`,
        data
    })
}

// 获取评估大项失分次数或分值
export function getGroupScoreLose(options, data) {
    return request({
        method: 'post',
        url: baseUrl + `/statisticsQuestion/groupScoreLose/${options.groupLevel}/${options.type}`,
        data
    })
}

// 导出评估大项失分次数或分值
export function exportGroupScoreLose(options, data) {
    return request({
        responseType: 'blob',
        method: 'post',
        url: baseUrl + `/statisticsQuestion/exportGroupStatistics/${options.groupLevel}`,
        data
    })
}

// 获取失分次数趋势分析
export function getQuestionTrend(timeScale, data) {
    return request({
        method: 'post',
        url: baseUrl + `/statisticsQuestion/questionTrend/${timeScale}`,
        data
    })
}

// 看趋势
export function getTrendById(timeScale, data) {
    return request({
        method: 'post',
        url: baseUrl + `/statisticsQuestion/trendById/${timeScale}`,
        data
    })
}

// 导出明细
export function exportDetailById(data) {
    return request({
        responseType: 'blob',
        method: 'post',
        url: baseUrl + `/statisticsQuestion/exportDetailById`,
        data
    })
}

// 导出评估大项得分率
export function exportGroupScoreRate(groupLevel, data) {
    return request({
        responseType: 'blob',
        method: 'post',
        url: baseUrl + `/statisticsQuestion/exportGroupScoreRate/${groupLevel}`,
        data
    })
}

// 导出评估问题的失分项
export function exportQuestionList(data) {
    return request({
        responseType: 'blob',
        method: 'post',
        url: baseUrl + `/statisticsQuestion/exportList`,
        data
    })
}

// 导出责任
export function exportOwnerById(options, data) {
    return request({
        responseType: 'blob',
        method: 'post',
        url: baseUrl + `/statisticsQuestion/exportOwnerById/${options.areaLevel}/${options.orderType}/${options.areaId}/${options.isEnd}`,
        data
    })
}

// 导出失分次数趋势分析
export function exportQuestionTrend(timeScale, data) {
    return request({
        responseType: 'blob',
        method: 'post',
        url: baseUrl + `/statisticsQuestion/exportQuestionTrend/${timeScale}`,
        data
    })
}

// 导出趋势
export function exportTrendById(timeScale, data) {
    return request({
        responseType: 'blob',
        method: 'post',
        url: baseUrl + `/statisticsQuestion/exportTrendById/${timeScale}`,
        data
    })
}

// 获取次级页面中的重复失分项详情
export function getLoseItemDetailInTable(params, data) {
    //let paraStr = options.pageNum ? `?pageNum=${options.pageNum}&pageSize=${options.pageSize}` : '';
    return request({
        method: 'post',
        url: baseUrl + `/statisticsQuestion/loseItemDetail`,
        params,
        data
    })
}
// 导出次级页面中的重复失分项详情
export function exportLoseItemDetailInTable(data) {
    return request({
        responseType: 'blob',
        method: 'post',
        url: baseUrl + `/statisticsQuestion/loseItemDetailExcel`,
        data
    })
}

// 获取起止日期内对应的有效任务
export function getTasksByAssessIds(data) {
    return request({
        method: 'post',
        url: baseUrl + `/statisticsSearch/getTasks`,
        data
    })
}
// 获取指定任务标准列表的树形分组
export function getGroupTreeByAssessIds(data) {
    return request({
        method: 'post',
        url: baseUrl + `/statisticsSearch/getGroupTree`,
        data
    })
}

// 获取整改明细
export function getDetail(data, options) {
    return request({
        method: 'post',
        url: baseUrl + `/statisticsCorrect/detail?pageNum=${options.pageNum}&pageSize=${options.pageSize}`,
        data
    })
}
// 获取整改执行力
export function getExecutive(data, options) {
    return request({
        method: 'post',
        url: baseUrl + `/statisticsCorrect/executive?pageNum=${options.pageNum}&pageSize=${options.pageSize}`,
        data
    })
}
// 获取整改数据概括、状态分布图子模块
export function getRectificationOverview(data) {
    return request({
        method: 'post',
        url: baseUrl + `/statisticsCorrect/overview`,
        data
    })
}
// 获取整改报告
export function getRectificationReport(corRecdId) {
    return request({
        method: 'post',
        url: baseUrl + `/statisticsCorrect/report/${corRecdId}`
    })
}
// 导出整改明细
export function exportDetail(data) {
    return request({
        responseType: 'blob',
        method: 'post',
        url: baseUrl + `/statisticsCorrect/exportDetail`,
        data
    })
}
// 导出整改执行力
export function exportExecutive(data) {
    return request({
        responseType: 'blob',
        method: 'post',
        url: baseUrl + `/statisticsCorrect/exportExecutive`,
        data
    })
}

// 导出整改状态分布图子模块
export function exportOverview(data) {
    return request({
        responseType: 'blob',
        method: 'post',
        url: baseUrl + `/statisticsCorrect/exportOverview`,
        data
    })
}

// 移动分组下的任务项
export function moveAssessItem(data) {
    return request({
        method: 'post',
        url: baseUrl + '/moveAssessItem',
        data
    })
}

// 移动分组
export function moveAssessGroup(data) {
    return request({
        method: 'post',
        url: baseUrl + '/moveAssessGroup',
        data
    })
}


// // 任务分组模板下载
// export function assessGroupImportTemplate (params) {
//   return request({
//     method: 'get',
//     url: baseUrl + '/assessGroupImportTemplate',
//     params
//   })
// }


// // 导入任务分组失败项下载
// export function exportAssessGroupErrorImport (params) {
//   return request({
//     method: 'get',
//     url: baseUrl + '/exportAssessGroupErrorImport',
//     params
//   })
// }



// 任务分组导入
export function importAssessGroupExcel(data, assessId) {
    return request({
        headers: { 'Content-Type': 'multipart/form-data' },
        url: baseUrl + `/importAssessGroupExcel/${assessId}`,
        method: 'post',
        data
    })
}

// 查看过期门店数
export function expireStoreCount(params) {
    return request({
        url: baseUrl + '/store/expireStoreCount',
        method: 'get',
        params
    })
}


// 获取任务分享报告
export function sharedReport(options, params) {
    return request({
        url: baseUrl + `/report/sharedReport/${options.tenant}/${options.taskRecordId}`,
        method: 'get',
        params
    })
}


// 获取证照报表
export function licenseReport(params) {
    return request({
        url: baseUrl + '/licenseReport/licenseReport',
        method: 'get',
        params
    })
}

// 获取缺失证照门店
export function storesMissingLicense(params) {
    return request({
        url: baseUrl + '/licenseReport/storesMissingLicense',
        method: 'get',
        params
    })
}

// 通过Excel文件导入证照
export function importLicensesByExcel(excelFormData) {
    return request({
        headers: { 'Content-Type': 'multipart/form-data' },
        url: baseUrl + '/license/licenseExcel',
        method: 'post',
        data: excelFormData
    })
}

// 导出证照报表
export function licenseReportExcel(state, type, expiredQuery) {
    const expiredQueryStr = expiredQuery ? '&expiredQuery=true' : ''
    return request({
        responseType: 'blob',
        method: 'post',
        url: baseUrl + `/licenseReport/licenseReportExcel?state=${state}&type=${type}${expiredQueryStr}`,
    })
}

// 导出证照未完善门店
export function storesMissingLicenseExcel(type) {
    return request({
        responseType: 'blob',
        method: 'post',
        url: baseUrl + `/licenseReport/storesMissingLicenseExcel?type=${type}`,
        // data
    })
}

// 获取证照种类
export function getLicenseTypes(params) {
    return request({
        url: baseUrl + `/license/licenseTypes`,
        method: 'get',
        params
    })
}

// 获取事件模板列表
export function getEventTemplateList(params) {
    return request({
        url: baseUrl + `/eventTemplate/templateList`,
        method: 'get',
        params
    })    
}
// 获取事件模板详情
export function getEventTemplateDetail(id) {
    return request({
        url: baseUrl + `/eventTemplate/templateDetail/${id}`,
        method: 'get'
    })    
}
// 新建或修改事件模板
export function saveEventTemplate(data) {
    return request({
        url: baseUrl + `/eventTemplate/template`,
        method: 'post',
        data
    })    
}
// 修改事件模板状态
export function updateEventTemplateState(etId, state) {
    return request({
        url: baseUrl + `/eventTemplate/state/${etId}/${state}`,
        method: 'put'
    })    
}
// 获取指定模板下事件项
export function getEventItemsBoundTemplate(params) {
    return request({
        url: baseUrl + `/eventTemplate/itemsBoundTemplate/${params.etId}`,
        method: 'get',
        params
    })    
}
// 获取未绑定指定模板的事件项
export function getEventItemsNotBoundTemplate(params) {
    return request({
        url: baseUrl + `/eventTemplate/itemsNotBoundTemplate/${params.etId}`,
        method: 'get',
        params
    })    
}
// 添加事件项到事件模板（可批量）
export async function addEventItems2EventTempt(data) {
    return request({
        url: baseUrl + `/eventTemplate/items2EventTempt`,
        method: 'post',
        data
    })    
}
// 从事件模板删除事件项（可批量）
export async function removeEventItemsFromTempt(data) {
    return request({
        url: baseUrl + `/eventTemplate/itemsFromTempt`,
        method: 'delete',
        data
    })    
}

// 查询事件报表
export function getEventReportList(data) {
    return request({
        url: baseUrl + `/eventReport/list`,
        method: 'post',
        data
    })
}
// 查看事件详情
export function getEventDetail(eventRecordId) {
    return request({
        url: baseUrl + `/eventReport/eventDetail/${eventRecordId}`,
        method: 'get',
    })
}

// 获取事件邮件分享详情
export function eventReport(options, params) {
    return request({
        url: baseUrl + `/eventReport/sharedReport/${options.tenant}/${options.eventRecordId}`,
        method: 'get',
        params
    })
}

// 查询事件项
export function getEventItems(params) {
    return request({
        url: baseUrl + `/eventReport/eventItems`,
        method: 'get',
        params
    })
}

// 事件报表删除
export function delEventReport(eventRecordId) {
    return request({
        url: baseUrl + `/eventReport/${eventRecordId}`,
        method: 'delete',
    })
}


// 事件报表导出
export function exportReport(data) {
    return request({
        responseType: 'blob',
        url: baseUrl + `/eventReport/listExport`,
        method: 'post',
        data
    })
}

// 视频监控，获取详情树状图
export function storesWithCamera(params) {
    return request({
        url: baseUrl + `/device/storesWithCamera`,
        method: 'get',
        params
    })
}

export function moveCamera(data) {
    return request({
        headers: { "Content-Type": "multipart/form-data" },
        url: "api/lapp/device/ptz/start",
        method: "post",
        data
    })
}

export function stopCamera(data) {
    return request({
        headers: { "Content-Type": "multipart/form-data" },
        url: "api/lapp/device/ptz/stop",
        method: "post",
        data
    })
}

// 获取指定设备的通道信息
export function getCameraInformation(data) {
    return request({
        headers: { "Content-Type": "multipart/form-data"},
        url: "https://open.ys7.com/api/lapp/device/camera/list",
        method: "post",
        data
    })
}


// 根据门店id获取门店访问令牌
export function getChildAccessToken(storeId) {
    return request({
        url: baseUrl + `/device/getChildAccessToken/${storeId}`,
        method: 'get',
    })
}

// 根据查询条件获取自定义任务报表
export function getReportTable(data) {
    return request({
        url: baseUrl + `/customTaskReport/reportTable`,
        method: 'post',
        data
    })
}

// 根据查询条件导出自定义任务报表
export function reportExcel(data) {
    return request({
        responseType: 'blob',
        url: baseUrl + `/customTaskReport/reportExcel`,
        method: 'post',
        data
    })
}

// 获取自定义任务详情
export function customTaskReportDetail(customTaskId) {
    return request({
        url: baseUrl + `/customTaskReport/detail/${customTaskId}`,
        method: 'get',
    })
}

// 获取包含自定义任务中的全部完成人
export function getFinishers() {
    return request({
        url: baseUrl + `/customTaskReport/finishers`,
        method: 'get',
    })
}


// 获取包含在自定义任务中的全部门店
export function getStores() {
    return request({
        url: baseUrl + `/customTaskReport/stores`,
        method: 'get',
    })
}

// 导出pdf
export function exportTaskDetailPDF(taskRecordId,reportShowType) {
    return request({
        timeout: 180000,
        responseType: 'blob',
        url: baseUrl + `/report/exportTaskDetailPDF/${taskRecordId}/${reportShowType}`,
        method: 'get',
    })
}
export function exportSharedReportPDF(tenant,taskRecordId,reportShowType) {
  return request({
    timeout: 180000,
    responseType: 'blob',
    url: baseUrl + `/report/exportSharedReportPDF/${tenant}/${taskRecordId}?reportShowType=${reportShowType}`,
    method: 'get',
  })
}
export function exportListExcel(data) {
  return request({
    timeout: 180000,
    responseType: 'blob',
    url: baseUrl + `/calendar/exportListExcel`,
    method: 'post',
    data
  })
}
export function exportLogExcel(data) {
  return request({
    timeout: 180000,
    responseType: 'blob',
    url: baseUrl + `/log/exportLoginRecords`,
    method: 'post',
    data
  })
}

// 获取评估标准满分以用于设置分数等级
export function getFullScore(assessId) {
    return request({
        url: baseUrl + `/fullScore/${assessId}`,
        method: 'get',
    })
}

// 等级分布
export function getLevelDistribution(data) {
    return request({
        method: 'post',
        url: baseUrl + `/statisticsScore/levelDistribution`,
        data
    })
}

// 获取点击”等级分布“某图例后跳转的评估结果叶页面数据
export function getLevelResult(level,data) {
    return request({
        method: 'post',
        url: baseUrl + `/statisticsScore/levelResult/${level}`,
        data
    })
}

// 导出等级分布图
export function levelDistributionExcel(data) {
    return request({
        responseType: 'blob',
        method: 'post',
        url: baseUrl + `/statisticsScore/levelDistributionExcel`,
        data
    })
}

// 导出获取点击”等级分布“某图例后跳转的评估结果叶页面数据
export function levelResultExcel(levelItem,data) {
    return request({
        responseType: 'blob',
        method: 'post',
        url: baseUrl + `/statisticsScore/levelResultExcel/${levelItem.level}/${levelItem.name}`,
        data
    })
}

// 获取迈外迪摄像头实时直播url
export function getLiveStreamUrl(mac) {
    return request({
        url: baseUrl + `/wiwide/liveStreamUrl/${mac}`,
        method: 'get',
    })
}
// 远程控制迈外迪设备PTZ
export function controlPTZ(mac, command) {
    return request({
        url: baseUrl + `/wiwide/controlPTZ/${mac}/${command}`,
        method: 'put',
    })
}
// 获取迈外迪摄像头实时截图访问链接
export function getScreenshot(mac) {
    return request({
        url: baseUrl + `/wiwide/screenshot/${mac}`,
        method: 'get',
    })
}

// 根据查询条件获取课程列表
export function getCourses(query) {
    return request({
        url: baseUrl + '/coursePc/courses',
        method: 'get',
        params: query
    })
}
// 获取课程详情
export function getCourseDetail(courseId) {
    return request({
        url: baseUrl + `/coursePc/detail/${courseId}`,
        method: 'get',
    })
}
// 新增或编辑课程
export function saveCourse(data) {
    return request({
        url: baseUrl + '/coursePc/course',
        method: 'post',
        data
    })
}
// 变更课程状态
export function setCourseState(courseId, state) {
    return request({
        url: baseUrl + `/coursePc/courseState/${courseId}/${state}`,
        method: 'put'
    })
}

// 获取全部课程分类
export function getCourseTypes() {
    return request({
        url: baseUrl + `/coursePc/courseTypes`,
        method: 'get',
    })    
}
// 新增或编辑课程分类
export function saveCourseType(data) {
    return request({
        url: baseUrl + '/coursePc/courseType',
        method: 'post',
        data
    })
}
// 删除课程分类
export function deleteCourseType(ctId) {
    return request({
        url: baseUrl + `/coursePc/courseType/${ctId}`,
        method: 'delete'
    })
}
// 获取指定分类下课程列表
export function getCoursesInType(ctId) {
    return request({
        url: baseUrl + `/coursePc/coursesInType/${ctId}`,
        method: 'get',
    })
}
// 按照提交的课程id列表进行排序
export function sortCourses(data) {
    return request({
        url: baseUrl + '/coursePc/courseListOrder',
        method: 'put',
        data
    })
}

// 根据查询条件获取课程资源列表
export function getCourseResources(query) {
    return request({
        url: baseUrl + '/courseResource/courseResources',
        method: 'get',
        params: query
    })
}
// 获取课程资源详情
export function getCourseResourceDetail(crId) {
    return request({
        url: baseUrl + `/courseResource/courseResourceDetail/${crId}`,
        method: 'get',
    })
}
// 新增或编辑课程资源
export function saveCourseResource(data) {
    return request({
        url: baseUrl + '/courseResource/courseResource',
        method: 'post',
        data
    })
}
// 删除课程资源
export function deleteCourseResource(crId) {
    return request({
        url: baseUrl + `/courseResource/courseResource/${crId}`,
        method: 'delete'
    })
}

// 获取指定课程下关联的资源
export function getCourseResourcesAssociated(courseId) {
    return request({
        url: baseUrl + `/courseResource/courseResourcesAssociated/${courseId}`,
        method: 'get'
    })
}
// 将指定资源关联至指定课程
export function associateCourseResource(courseId, data) {
    return request({
        url: baseUrl + `/courseResource/courseResourcesAssociated/${courseId}`,
        method: 'post',
        data
    })
}
// 解除课程与资源的关联
export function removeCourseResource(courseId, crId) {
    return request({
        url: baseUrl + `/courseResource/courseResourcesAssociated/${courseId}/${crId}`,
        method: 'delete'
    })
}
// 按照提交的课程资源id列表进行排序
export function sortCourseResource(courseId, data) {
    return request({
        url: baseUrl + `/courseResource/courseResourcesOrder/${courseId}`,
        method: 'put',
        data
    })
}

// 获取全部已学习课程
export function getCoursesLearned() {
    return request({
        url: baseUrl + '/courseLearn/coursesLearned',
        method: 'get'
    })    
}

// 获取课程学习进度报表数据
export function loadCourseLearnReport(data) {
    return request({
        url: baseUrl + '/courseLearn/loadCourseLearnReport',
        method: 'post',
        data
    })
}

// 导出课程学习进度报表Excel
export function exportCourseLearnReport(data) {
    return request({
        timeout: 180000,
        responseType: 'blob',        
        url: baseUrl + '/courseLearn/exportCourseLearnReport',
        method: 'post',
        data
    })
}

// 获取全部已学习课程资源
export function getResourcesLearned() {
    return request({
        url: baseUrl + '/courseLearn/resourcesLearned',
        method: 'get'
    })     
}

// 获取课程资源学习进度报表数据
export function loadCourseResourceLearnReport(data) {
    return request({
        url: baseUrl + '/courseLearn/loadCourseResourceLearnReport',
        method: 'post',
        data
    })
}

// 导出课程资源学习进度报表Excel
export function exportCourseResourceLearnReport(data) {
    return request({
        timeout: 180000,
        responseType: 'blob',
        url: baseUrl + '/courseLearn/exportCourseResourceLearnReport',
        method: 'post',
        data
    })
}

// 前端获取临时访问OSS凭证
export function getAssumeRole() {
    return request({
        url: baseUrl + '/oss/assumeRole',
        method: 'get'
    })    
}

//获取覆盖率预览数据
export function getCoveragePreviews(query) {
    return request({
        url: baseUrl + '/coveragePc/coveragePreviews',
        method: 'get',
        params: query
    })
}
//获取覆盖率执行人页面数据
export function getCoverageRecordPage(coverageId, state) {
    return request({
        url: baseUrl + `/coveragePc/coverageRecordPage/${coverageId}/${state}`,
        method: 'get'
    })
}
//导出覆盖率执行人页面报表
export function exportCoverageRecordPage(coverageId) {
    return request({
        timeout: 180000,
        responseType: 'blob',
        url: baseUrl + `/coveragePc/coverageRecordExcel/${coverageId}`,
        method: 'get'
    })
}
//获取覆盖率门店完成详情数据
export function getCoverageDetails(crId) {
    return request({
        url: baseUrl + `/coveragePc/coverageDetails/${crId}`,
        method: 'get'
    })
}
//导出覆盖率门店完成详情报表
export function exportCoverageDetails(crId) {
    return request({
        timeout: 180000,
        responseType: 'blob',
        url: baseUrl + `/coveragePc/coverageDetailExcel/${crId}`,
        method: 'get'
    })
}
//创建覆盖率
export function createCoverage(data) {
    return request({
        url: baseUrl + '/coveragePc/coverage',
        method: 'post',
        data
    })
}
//编辑覆盖率
export function editCoverage(data) {
    return request({
        url: baseUrl + '/coveragePc/coverage',
        method: 'put',
        data
    })    
}
//发布覆盖率
export function publishCoverage(coverageId) {
    return request({
        url: baseUrl + `/coveragePc/state/${coverageId}`,
        method: 'put'
    })
}
//删除覆盖率
export function deleteCoverage(coverageId) {
    return request({
        url: baseUrl + `/coveragePc/coverage/${coverageId}`,
        method: 'delete'
    })
}